import React, { useState } from 'react'

// Bootstrap If Required
import { Form, InputGroup, Col } from 'react-bootstrap'
import { FaCopy } from 'react-icons/fa'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import firebase from '../../firestore'
const Header = (props) => {
    let userDetails = props.userDetails
    const [copied, setCopied] = useState(false);
    return (
        <div className="header_Dashboard">
            <h1>Welcome </h1>
            <h1>{firebase.auth().currentUser.displayName}</h1>
            <h3>What we've got on you</h3>
            <Form>
                <Form.Group as={Col} md="7" style={{ marginTop: 20 }} controlId="validationCustomUsername">
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Username"
                            aria-describedby="inputGroupPrepend"
                            required
                            value={"https://fresume.in/" + userDetails.username}

                        />
                        <InputGroup.Prepend>
                            <CopyToClipboard
                                text={"https://fresume.in/" + userDetails.username}
                                onCopy={() => setCopied(true)}
                            >
                                <InputGroup.Text id="inputGroupPrepend" disabled><FaCopy /></InputGroup.Text>
                            </CopyToClipboard>
                        </InputGroup.Prepend>

                    </InputGroup>
                    {copied ? <p>Copied...</p> : null}

                </Form.Group>
            </Form>
        </div>
    )
}

export default Header;